import { trans } from '@spotahome/soyuz/client';

import { useMediatorModalHandle } from '../utils/withModalHandle';
import { OPEN_DEPOSIT_PROTECTION_MODAL } from '../utils/constants';

import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import styles from './DepositProtectionModal.module.scss';

const DepositProtectionModal = () => {
  const { isModalOpen, handleModalClose } = useMediatorModalHandle({
    channel: OPEN_DEPOSIT_PROTECTION_MODAL
  });

  return isModalOpen ? (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={handleModalClose}
      size="medium"
      className={styles['deposit-protection-modal']}
    >
      <ModalHeader
        className={styles['deposit-protection-modal__header']}
        onRequestClose={handleModalClose}
        label={trans('listing.labels.deposit-protected.title')}
      />
      <ModalBody className={styles['deposit-protection-modal__body']}>
        <p>
          {trans('deposit-protected.modal.body')}
          <br />
          <br />
          {trans('deposit-protected.modal.body-2')}
        </p>
      </ModalBody>
    </Modal>
  ) : null;
};

export default DepositProtectionModal;
